'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _CursorHintDesign = require('./CursorHintDesign');

var _CursorHintDesign2 = _interopRequireDefault(_CursorHintDesign);

var CursorHint = (function (_React$Component) {
  _inherits(CursorHint, _React$Component);

  _createClass(CursorHint, null, [{
    key: 'defaultProps',
    value: {
      delay: 879,
      DesignComponent: _CursorHintDesign2['default'],
      hints: null
    },
    enumerable: true
  }]);

  function CursorHint(props) {
    var _this = this;

    _classCallCheck(this, CursorHint);

    _get(Object.getPrototypeOf(CursorHint.prototype), 'constructor', this).call(this, props);

    this.show = function () {
      _this.setState({ show: true });
    };

    this.handleMouseMove = function (e) {
      clearTimeout(_this._showSetT);

      _this.setState({
        show: false,
        x: e.clientX + 7,
        y: e.clientY + 7
      }, function () {
        _this._showSetT = setTimeout(_this.show, _this.props.delay);
      });
    };

    this.state = {};
  }

  _createClass(CursorHint, [{
    key: 'getParentWindow',
    value: function getParentWindow() {
      var node = _reactDom2['default'].findDOMNode(this);
      return node.ownerDocument.defaultView;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getParentWindow().addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this._showSetT);
      this.getParentWindow().removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'render',
    value: function render() {
      var hint = this.props.hint;
      var DesignComponent = this.props.DesignComponent;
      var _state = this.state;
      var show = _state.show;
      var x = _state.x;
      var y = _state.y;

      return show && hint ? _react2['default'].createElement(DesignComponent, { hint: hint, x: x, y: y }) : _react2['default'].createElement('div', { hidden: true });
    }
  }]);

  return CursorHint;
})(_react2['default'].Component);

exports['default'] = CursorHint;
module.exports = exports['default'];
//# sourceMappingURL=CursorHint.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/transhand/lib/cursorHint/CursorHint.js
 ** module id = 560
 ** module chunks = 0
 **/